export const promotionList_api = {
  url: 'promotionList',
  method: 'post',
  title: '优惠详情列表',
}

export const export_api = {
  url: 'promotionListsDownload',
  method: 'post',
  title: '优惠详情列表导出',
}


// WEBPACK FOOTER //
// ./src/views/base/promotion/desc.js